import { connect } from 'react-redux'
import PhotographicComponent from '../components/PhotographicComponent.jsx';
import {

	forwardToExpandMenuMax,
	forwardToUploadPhoto,
	forwardToMarkQueue,
	forwardToMarkPop,
	forwardToFindPhotos,
	cleanCheckCardAlert,
	forwardChangeIsLoadingPage

} from '../actions';

const mapStateToProps = (state) => ({
	menu: state.getIn(['menuReducer', 'menu']),

	alert: state.getIn(['checkCardReducer', 'alert']),
	view: state.getIn(['checkCardReducer', 'view']),
	request: state.getIn(['checkCardReducer', 'request']),
	isLoadingPage: state.getIn(['checkCardReducer', 'isLoadingPage']),
	// 前一頁
	previousPage : state.getIn(['checkCardReducer', 'previousPage']),

	previous: state.getIn(['maintenanceCardsReducer', 'mCardListRequestModel']),
	previousView: state.getIn(['maintenanceCardsReducer', 'mCardListViewModel'])
})

const mapDispatchToProps = (dispatch) => ({

	expandContent: () =>{
		dispatch(forwardToExpandMenuMax());
	},

	uploadPhoto: (dataUri, card, category, operator, ignoreCardChecking) =>{
		let type;
		if(0===category){
			type="CLOTH";
		}
		if(1===category){
			type="PANT";
		}
		dispatch(forwardToUploadPhoto(dataUri, card, type, "PRE", operator, ignoreCardChecking));
	},
	
	queue: () =>{
		dispatch(forwardToMarkQueue());
	},

	findPhotos: (card, category) => {
		let type;
		if (0 === category) {
			type = "CLOTH";
		}
		if (1 === category) {
			type = "PANT";
		}
		dispatch(forwardToFindPhotos(card, type, "PRE"));
	},

	pop: (dataUri) =>{
		dispatch(forwardToMarkPop(dataUri));
	},

	cleanAlert: () => {
		dispatch(cleanCheckCardAlert());
	},

	changeIsLoadingPage: (isLoading) => {
		dispatch(forwardChangeIsLoadingPage(isLoading));
	}
})

const PhotographicContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhotographicComponent)

export default PhotographicContainer;


// WEBPACK FOOTER //
// ./src/containers/PhotographicContainer.jsx